import * as React from "react";
import {Checkbox, Icon, Input, Modal, TextArea} from "semantic-ui-react";
import {formatDate} from "../../../components/Table/dataHandler/Utils";
import Button from "../../../components/Button";
import {ENewsPriority, MaintenanceDto, NewsDto} from "../../../services/Client";

interface IMaintenanceTextUpdateDialogProps {
    editItem?: MaintenanceDto;
    /** Callback when the user exits the dialog. */
    onExitDialog: (maintenanceDto?: MaintenanceDto) => any;
    t: reactI18Next.TranslationFunction;
}

interface IMaintenanceTextUpdateDialogState {
    title: string;
    content: string;
    active: boolean;
}

class MaintenanceTextUpdateDialog extends React.Component<IMaintenanceTextUpdateDialogProps, IMaintenanceTextUpdateDialogState> {
    TITLE_SIZE = 50;
    CONTENT_SIZE = 2048;

    constructor(props: IMaintenanceTextUpdateDialogProps) {
        super(props);

        this.state = {
            title: "",
            content: "",
            active: true
        };
    }

    componentDidMount() {
        const {editItem} = this.props;
        if (editItem) {
            this.setState({
                title: editItem.title,
                content: editItem.content,
                active: editItem.active === undefined ? true : editItem.active,
            });
        }
    }

    onClickCreate = (): void => {
        if (this.isFormValid() && this.props.editItem) {
            const newsDto: MaintenanceDto = {
                title: this.state.title.trim(),
                content: this.state.content.trim(),
                active: this.state.active,
                objectId: this.props.editItem.objectId,
                versionId: this.props.editItem.versionId,
            };

            this.props.onExitDialog(newsDto);
        }
    }

    isFormValid = (): boolean => {
        const {active} = this.state;
        const title = this.state.title.trim();
        const content = this.state.content.trim();
        const {editItem} = this.props;

        if (title.length > 0 && content.length > 0 && title.length <= this.TITLE_SIZE && content.length <= this.CONTENT_SIZE) {
            if (editItem) {
                return editItem.content !== content || editItem.title !== title || editItem.active !== active;
            }
            return true;
        }
        return false;
    }

    render() {
        const {
            editItem,
            onExitDialog,
            t
        } = this.props;
        return (
            <Modal open={true}>
                <Modal.Header>
                    <div className='display--flex align-items--center justify-content--space-between'>
                        <span>
                            <Icon name='newspaper outline' size='large' />
                            {t("NOTES_AND_NEWS:EDIT_PRE_LAND_CONFIG")}
                        </span>
                        {editItem && editItem.metadata &&
                            <div style={{fontSize: 14, color: 'grey', fontWeight: 'normal'}}>
                                {editItem.metadata.changedTimestamp && editItem.metadata.changedTimestamp !== editItem.metadata.createdTimestamp &&
                                    <span>{t("NOTES_AND_NEWS:EDITED")}: {formatDate(editItem.metadata.changedTimestamp)}</span>
                                }
                            </div>
                        }
                    </div>
                </Modal.Header>
                <Modal.Content>
                    <div className='margin-bottom--10px'>
                        <label className='width--100Percent'>
                            <b>{t("NOTES_AND_NEWS:TITLE")}</b>
                        </label>
                        <Input
                            fluid={true}
                            value={this.state.title}
                            onChange={(e, v) => this.setState({title: v.value.substring(0, this.TITLE_SIZE)})}
                        />
                    </div>
                    <div>
                        <label className='width--100Percent'>
                            <b>{t("NOTES_AND_NEWS:CONTENT")}</b>
                        </label>
                        <TextArea
                            style={{width: "100%", height: 500, padding: 10}}
                            value={this.state.content}
                            onChange={(e) => this.setState({content: e.currentTarget.value.substring(0, this.CONTENT_SIZE)})}
                        />
                        <span>{this.CONTENT_SIZE - this.state.content.length} {t("NOTES_AND_NEWS:CHAR_LEFT")}</span>
                    </div>
                    <div className='display--flex align-items--center margin-top--10px'>
                        <label className='margin-right--10px'>
                            <b>{t("NOTES_AND_NEWS:ACTIVE")}</b>
                        </label>
                        <Checkbox
                            toggle={true}
                            checked={this.state.active}
                            onChange={(e, v) => this.setState({active: !this.state.active})}
                        />
                    </div>
                </Modal.Content>
                <Modal.Actions>
                    <Button
                        icon={"checkmark"}
                        onClick={this.onClickCreate}
                        disabled={!this.isFormValid()}
                    />
                    <Button
                        icon={"ban"}
                        onClick={() => onExitDialog()}
                    />
                </Modal.Actions>
            </Modal>
        );
    }
}

export default MaintenanceTextUpdateDialog;



// WEBPACK FOOTER //
// ./src/views/AdminView/NotesAndNewsTab/MaintenanceTextUpdateDialog.tsx